import { render, staticRenderFns } from "./TrainingListDetail.vue?vue&type=template&id=2d0228a8&scoped=true&"
import script from "./TrainingListDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingListDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingListDetail.vue?vue&type=style&index=0&id=2d0228a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0228a8",
  null
  
)

export default component.exports